import { Controller } from '@hotwired/stimulus'
import type { ModalPortalPayloadMap } from '@app/types'

export default class extends Controller {
  static values = {
    id: String,
    params: Object,
  }

  declare idValue: string
  declare paramsValue: ModalPortalPayloadMap[keyof ModalPortalPayloadMap]

  open(e: Event): void {
    e.preventDefault()
    e.stopPropagation()

    window.modalCitizen.openModalPortal(
      this.idValue as keyof ModalPortalPayloadMap,
      this.paramsValue
    )
  }
}
